import { Component, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Output, Input, EventEmitter } from '@angular/core';
import { AnalyticsService, DevicesUtilVM, UtilSchoolProjectVM } from '../../services/api';
import { DatePipe } from '@angular/common';
import { scaleBand } from 'd3-scale';
import {MatSort, Sort} from '@angular/material/sort';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import { Router } from '@angular/router';

@Component({
	selector: 'util-device-report',
	templateUrl: 'util-device-report.component.html',
	styleUrls: ['util-device-report.component.scss'],
	providers: [DatePipe]

})

export class UtilDeviceReportComponent implements OnInit, OnChanges {
	@Input() schoolId:number = -1;
	@Input() projectId:number | undefined = -1;
	@Input() isout:boolean | undefined = false;
	@Input() outstartDate: Date = new Date();
	@Input() outendDate: Date = new Date();
	@Output() backEvent = new EventEmitter();
	

	displayedColumns: string[] = ['chart','deviceName','deviceType','regDate','lastSynched','scanDate'];;
	reportdata :any[] = [];
	
	dataSource = new MatTableDataSource<DevicesUtilVM>(this.reportdata);
	@ViewChild(MatPaginator) paginator: MatPaginator|null = null;
	// options
	view : [number, number] = [100,50];
	legend: boolean = true;
	showLabels: boolean = true;
	animations: boolean = true;
	xAxis: boolean = true;
	yAxis: boolean = true;
	showYAxisLabel: boolean = true;
	showXAxisLabel: boolean = true;
	colorScheme = [{"name": "utilization","value": "#4F94D3"}];
	timeline: boolean = true;
	currentDate : string = '';
	startDate: Date = new Date();
	endDate: Date = new Date();


	ngOnInit() { 
		if(this.schoolId != -1){
			this.getSchoolReports()
		}

	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes.outstartDate){
			this.outstartDate = new Date(changes.outstartDate.currentValue);
			console.log(this.outstartDate);
			const today = new Date()
			let day = 86400000
			this.endDate = new Date(this.outstartDate.getTime() + (90 * day));
			if(!this.isout)
				this.startDate = new Date(today.getTime() - (365 * day));
			else{
				this.startDate = this.outstartDate;
				this.endDate = this.outendDate;
			}

			if(this.schoolId != -1){
				this.getSchoolReports()
			}

	}
		
	}


	private getDateString(day:Date){
		if(day == null) day = new Date();
		return this.datePipe.transform(day, 'yyyy-MM-dd')!;
	}

	onSelectDate(){
		if(this.schoolId != -1){
			this.getSchoolReports()
		}
	}

	currentData:any[] = [];
	private getSchoolReports(){
		this.service.analyticsGetUtilDeviceSchoolReportPost(this.schoolId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			console.log(data);
			data.forEach((value) => {
				this.currentData.push(this.getGridData(value));
			})
			
			this.dataSource = new MatTableDataSource<DevicesUtilVM>(this.currentData);
			this.reportdata = data;
			console.log(this.dataSource);
			this.dataSource.paginator = this.paginator;
		});
	}



	navigateBack(){
		this.backEvent.next(null);
	}

	constructor(private service: AnalyticsService, 
		private datePipe: DatePipe, 
		private router: Router) {
		const today = new Date()
		let day = 86400000
		this.startDate = new Date(today.getTime() - (3 * 30 * day));
	}


	getData(day: string, sync: number, total:number){
		console.log('sync' + sync);
		let util = (sync*1.0)/(total*1.0);
		util = Math.round(util * 100);
		return  {name:day.split('T')[0],value:util,toolTipText:''};
	}

	public schoolsSortChange(sort:Sort){
		const data = this.reportdata.slice();
		if (!sort.active || sort.direction === '') {
		this.reportdata = data;
		return;
		}
		 
		this.reportdata = data.sort((a, b) => {
		const isAsc = sort.direction === 'asc';
		switch (sort.active) {
			case 'deviceName': return this.compare(a['deviceName'], b['deviceName'], isAsc);
			case 'lastSync': return this.compare(a['latestSyncDate'], b['latestSyncDate'], isAsc);
			case 'lastScan': return this.compare(a['lastScanDate'], b['lastScanDate'], isAsc);
			case 'regDate': return this.compare(a['createdAt'], b['createdAt'], isAsc);
			case 'deviceType': return this.compare(a['deviceType'], b['deviceType'], isAsc);
			default: return 0;
		}
		});
		this.dataSource = new MatTableDataSource<DevicesUtilVM>(this.reportdata);
		this.dataSource.paginator = this.paginator;
	}
	  


compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

private getGridData(item:any){
	return {
		deviceName:item.deviceName,
		deviceType:item.deviceType,
		deviceId:item.deviceId,
		createdAt:item.createdAt,
		latestSyncDate:item.latestSyncDate,
		lastScanDate:item.lastScanDate,
		data : [
			{
			  "name": "Active",
			  "value": item.activeDays
			},
			{
			  "name": "Not-Active",
			  "value": this.getDifferenceInDays(this.startDate, this.endDate) -  item.activeDays
			}
		  ]
	}
}

navigateTo(entity:DevicesUtilVM){
	console.log(entity);
    this.router.navigate(["/admin/devices",entity.deviceId])
  }

barChartcustomColors = 
	[
	  { name: "Active", value: '#D9B300' },
	  { name: "Not-Active", value: '#12239E' }
	]

getDifferenceInDays(date1:any, date2:any) {
	const diffInMs = Math.abs(date2 - date1);
	return Math.round(diffInMs / (1000 * 60 * 60 * 24));
  }



	 
}